<template>
  <v-container>
    <div style="background-color: rgb(230, 233, 242); padding-left: 20px; padding-right: 20px; padding-bottom: 15px;">
        <v-row>
          <v-col cols="12" md="12">
            <h2 style="font-size: 2.5rem; color: rgb(0, 30, 67)">Recursos</h2>
            Esta sección reúne herramientas adicionales y enlaces a sitios web que complementan la información proporcionada en <b style="color: rgb(0, 30, 67)">IDmaderas</b>. También encontrarás 
            contenido elaborado por el Equipo Ambiental de UNODC e instituciones forestales peruanas para profundizar en temas de regulación forestal y conservación. Aprovecha estos 
            recursos para seguir aprendiendo y mejorar tus capacidades técnicas. 
          </v-col>
        </v-row>
        <v-row class="mb-1 justify-center mb-n1">
            <v-col class="mb-1" md="3">            
              <v-card class="mx-auto card-hover" max-width="100%" theme="dark" style="border-top: 5px solid #009DDC; margin-top: 5px; text-align: center;">
                <a href="https://biolink.website/HerramientasEquipoAmbiental" target="_blank" style="text-decoration: none;">
                  <v-tooltip bottom color="rgb(0, 124, 186)">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-img class="align-end text-white" contain height="120" :src="require('../assets/recurso1.png')"></v-img>
                        <p style="font-size: 1rem; color: rgb(15, 135, 201);"><b>Equipo Ambiental</b></p>
                      </div>
                    </template>
                    <span style="font-size: 0.9rem; color: white;">Enlace a Herramientas Equipo Ambiental.</span>
                  </v-tooltip>
                </a>
              </v-card>
            </v-col>
            <v-col class="mb-1" md="3"> 
              <v-card class="mx-auto card-hover" max-width="100%" theme="dark" style="border-top: 5px solid #009DDC; margin-top: 5px; text-align: center;">
                <a href="https://biolink.website/RecusosForestales" target="_blank" style="text-decoration: none;">
                  <v-tooltip bottom color="rgb(0, 124, 186)">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-img class="align-end text-white" contain height="120" :src="require('../assets/recurso2.png')"></v-img>
                        <p style="font-size: 1rem; color: rgb(15, 135, 201);"><b>Socios</b></p>
                      </div>
                    </template>
                    <span style="font-size: 0.9rem; color: white;">Enlace a Socios.</span>
                  </v-tooltip>
                </a>
              </v-card>
            </v-col>
          </v-row>
          <br><br>
          <v-row>
              <v-col cols="12" lg="4">
                  <v-img class="align-end text-white" contain width="320" :src="require('../assets/A1.jpeg')"></v-img> 
              </v-col>
              <v-col cols="12" lg="4">
                  <v-img class="align-end text-white" contain width="320" :src="require('../assets/A2.jpg')"></v-img> 
              </v-col>
              <v-col cols="12" lg="4">
                  <v-img class="align-end text-white" contain width="320" :src="require('../assets/A3.jpg')"></v-img> 
              </v-col>
          </v-row>
    </div>
  </v-container>
</template>
  
<script>
  export default {
    name: 'HelloWorld',

    data: () => ({
      
    }),
  }
</script>
<style>
    p {
      font-family: 'Heebo', sans-serif !important;
        font-size: 17px;        
        line-height: 1.6em;
    }
    h1 {
      font-family: 'Heebo', sans-serif !important;
        font-size: 2.5rem;
    }
    h2 {
      font-family: 'Sofia Sans', sans-serif !important;
    }
    h3 {
      font-family: 'Sofia Sans', sans-serif !important;
    }
    h5 {
        font-family: 'Sofia Sans', sans-serif !important;
        font-size: 1.25rem;
    }    
</style>